export const StatCard = ({ label, value, icon: Icon, tone = "emerald", testId, sub, delay = 0 }) => {
  const tones = {
    emerald: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    slate: "bg-slate-100 text-slate-700",
    sky: "bg-sky-50 text-sky-700",
  };
  return (
    <div className="rise rounded-2xl border border-slate-200 bg-white p-5 transition-shadow duration-200 hover:shadow-md" style={{ animationDelay: `${delay}ms` }}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</p>
        {Icon && (
          <span className={`flex h-9 w-9 items-center justify-center rounded-lg ${tones[tone]}`}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <p className="mt-3 font-mono text-xl font-bold text-slate-900 md:text-2xl" data-testid={testId}>{value}</p>
      {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
    </div>
  );
};
